import { Component, ElementRef, ViewChild, OnDestroy, HostListener, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MycontentserviceService } from 'src/app/_service/mycontentservice.service';
import { CategoryService } from 'src/app/_service/category.service';
import { Subscription, forkJoin, throwError } from 'rxjs';
import { URLS } from 'src/app/constants/URLS';
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { IndexedDbServiceService } from 'src/app/_service/indexed-db-service.service';
import { WalletinfoService } from 'src/app/_service/walletinfo.service';
import { Location } from '@angular/common';
import { WhiteLabelService } from 'src/app/_service/white-label.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AxinomDrmService } from 'src/app/_service/axinom-drm.service';
import { VidsPlayerComponent } from '../../sharedComponents/vids-player/vids-player.component';
import { IosFairplayPlayerComponent } from '../../sharedComponents/ios-fairplay-player/ios-fairplay-player.component';
import { IosBridgeService } from 'src/app/_service/ios-bridge.service';
import { DeviceService } from 'src/app/_service/tv-detect.service';
import { AuthenticateserviceService } from 'src/app/_service/authenticateservice.service';
import { environment } from 'src/environments/environment';
import { getVideoThumbnail, getVideoStreamFile, getMediaId } from 'src/app/utils/media-url.utils';
import { LiveStreamService } from 'src/app/_service/live-stream.service';
import { LiveStream } from 'src/app/_model/live-stream.model';
import { interval, Subscription as RxSub } from 'rxjs';

declare let shaka: any;
declare let window: any;

@Component({
  selector: 'app-shaka-player',
  templateUrl: './shaka-player.component.html',
  styleUrls: ['./shaka-player.component.css'],
})
export class ShakaPlayerComponent implements OnInit, OnDestroy {
  @ViewChild('customPlayer', { static: false }) customPlayerRef!: VidsPlayerComponent;
  @ViewChild('iosPlayer', { static: false }) iosPlayerRef!: IosFairplayPlayerComponent;
  videoElement: HTMLVideoElement | undefined;
  videoContainerElement: HTMLDivElement | undefined;
  player:any;
  mediaUrl: string = '';
  videoTitle: string = '';
  startTime: number = 0;
  postVideos: any = URLS.mediaUrl; 

  mpd_fileName: string = '';
  userId: string;
  channelId: number = 0;
  vidLibId: number = 0;
  videoType: string = '';
  videoDuration: number = 0;
  videoFileSize: number = 0;
  offlineUri: string = '';
  
  isMoreLikeThis: boolean = false;
  moreLikeThis: any[] = [];
  series_id: any;
  seriesData: any[] = [];
  seasons: any[] = [];
  selectedVideo: any;
  selectedSeason: any;
  selectedEpisode: any;
  activeTab: any = '';

  private currentVideoRunningTime: number = 0;
  isPlaying: boolean = false;
  
  delayTimer: number = 3;
  isNextVideoPreview: boolean = false;
  countdownInterval: any;
  nextVideoItem: any;
  currentlyPlayingEpisodeId: any | null = null;

  controlsHidden = false;
  private hideControlsTimeout: any;
  private routeSubscription: Subscription | undefined;

  isLoading:boolean = false;

  featureType:string = 'flixs'
  playerTheme:string = 'flixs';

  poster:string = '';

  isTrailer:boolean = false;

  // --- Live streaming state ---
  isLive: boolean = false;
  liveStreamId: number = 0;
  liveStream: LiveStream | null = null;
  liveViewerCount: number = 0;
  private liveHeartbeatSub: RxSub | undefined;
  private liveViewerPollSub: RxSub | undefined;

  constructor(
    private route: ActivatedRoute,
    private mycontentserviceService: MycontentserviceService,
    private categService: CategoryService,
    private http: HttpClient,
    private indexedDBService: IndexedDbServiceService,
    private router: Router,
    private walletService: WalletinfoService,
    private location: Location,
    private cdr: ChangeDetectorRef,
    private whitelabelService: WhiteLabelService,
    private breakpointObserver: BreakpointObserver,
    private axinomService: AxinomDrmService,
    private iosBridgeService: IosBridgeService,
    private deviceService: DeviceService,
    private authService: AuthenticateserviceService,
    private liveStreamService: LiveStreamService
  ) {}

  async ngOnInit() {
    if (this.authService.isGuest()) {
      this.router.navigate(['/v'], { replaceUrl: true });
      return;
    }
    const userId =  localStorage.getItem('userId');
    this.setMouseActivityListeners();
    await this.axinomService.loadDrmData(userId);
    this.subscribeToRouteParams();
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe(result => {
      if (result.matches) {
        this.featureType = 'vids';
      }
    });
  }

  ngOnDestroy(): void {
    localStorage.removeItem('videoCurrentTime');
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    if (this.hideControlsTimeout) {
      clearTimeout(this.hideControlsTimeout);
    }
    if (this.isLive) {
      this.stopViewerLifecycle();
      if (this.liveStreamId) {
        this.liveStreamService.leaveStream(this.liveStreamId).subscribe();
      }
      return;
    }
    if (!this.offlineUri) {
      this.updateWatchHistory();
      if (!this.isTrailer) {
        this.insertWatchEntry();
      }
    }
  }

  private subscribeToRouteParams() {
    this.userId = localStorage.getItem('userId');
  
    this.routeSubscription = this.route.params.subscribe(params => {
      // --- Live streaming branch ---
      this.isLive = this.router.url.includes('/live/event/');
      if (this.isLive) {
        const liveId = Number(params['id']);
        if (liveId && liveId !== this.liveStreamId) {
          this.liveStreamId = liveId;
          this.playerTheme = 'flixs';
          this.loadLiveStream(liveId);
        }
        return;
      }

      const newVidLibId = params['vidLibId'] || 0;
      const newSeriesId = params['series_id'];
      const fileName = params['fileName'];
      this.videoTitle = params['title'] || params['episodeTitle'] || params['movie'] || '';
      this.isTrailer = this.router.url.includes('/trailer/');
      if(this.isTrailer){
        this.vidLibId = newVidLibId;
        this.mediaUrl = `${this.postVideos}${fileName}`;
        this.selectedVideo = null;
        this.playerTheme = 'trailer';
        if (this.vidLibId) {
          this.getSelectedVideo(this.vidLibId);
        }
        return;
      }
      this.route.queryParams.subscribe(queryParams => {
        const newOfflineUri = queryParams['offlineUri'] ? decodeURIComponent(queryParams['offlineUri']) : '';
        if ( newVidLibId !== this.vidLibId || newSeriesId !== this.series_id || newOfflineUri !== this.offlineUri ) {
          this.vidLibId = newVidLibId;
          this.mpd_fileName = getVideoStreamFile(newVidLibId);
          this.series_id = newSeriesId;
          this.offlineUri = newOfflineUri;
          this.selectedVideo = null;
          this.mediaUrl = '';
          this.currentVideoRunningTime = 0;
          this.startTime = 0;
          this.clearNextVideoCountdown();
          this.setupVideoConfiguration();
          if (this.vidLibId) {
            this.getSelectedVideo(this.vidLibId);
          }
          if(this.offlineUri){
            console.log('i am inside the offlineuri');
            this.videoTitle = params['movie'];
            console.log(this.videoTitle);
          }
        }
      });
    });
  }  

  private async setupVideoConfiguration() {
    if (this.offlineUri) {
      this.mediaUrl = this.offlineUri;
      this.selectedVideo = {
        vidLidId: this.vidLibId,
        videoTitle: this.videoTitle,
        preparedVideoType: 'FREE',
        isChannelSubscribed: true,
        isPpvSubscribed: true
      }
      this.initPlayer();
      return;
    }
    const isApple = this.isSafariApple();
    if (isApple) {
      this.mediaUrl = `${this.postVideos}${getVideoStreamFile(this.selectedVideo || this.vidLibId, '_master.m3u8')}`;
    } else {
      this.mediaUrl = `${this.postVideos}${this.mpd_fileName}`;
    }
    console.log("mediaurl", this.mediaUrl);
  }
  
  private async initPlayer() {
    if (!this.customPlayerRef) {
      setTimeout(() => this.initPlayer(), 100);
      return;
    }
    try {
      if (this.player) {
        try {
          await this.player.destroy();
          this.player = null;
        } catch (error) {
          console.warn('Error destroying previous player:', error);
        }
      }
      shaka.polyfill.installAll();
      if (shaka.Player.isBrowserSupported()) {
        await this.indexedDBService.ensureDbInitialized();
        const token: string = localStorage.getItem('token');
        // const drmServersConfig = {
        //   'com.widevine.alpha': `https://widevine-dash.ezdrm.com/proxy?pX=C487BC&userId=${token}&channelId=${this.channelId}&vidLibId=${this.vidLibId}&videoType=${this.videoType}`
        // };
        const drmServersConfig = {
          'com.widevine.alpha': this.axinomService.getWidevineUrl()
        };
        const drmConfig = {
          servers: drmServersConfig,
          advanced: {
            'com.widevine.alpha': {
              persistentStateRequired: true
            }
          },
        };
        await this.customPlayerRef.initShakaPlayer(this.mediaUrl, drmConfig);
        this.videoElement = this.customPlayerRef.videoElement;
        this.player = this.customPlayerRef.player;
        try {
          await this.videoElement.play();
        } catch (playError) {
          console.warn('Auto-play failed:', playError);
        }
      }
    } catch (error) {
      console.error('Player initialization error:', error);
      this.isLoading = false;
    }
  }

  // ============================================================
  // LIVE STREAMING
  // ============================================================

  private loadLiveStream(streamId: number): void {
    this.isLoading = true;
    this.mediaUrl = '';
    this.selectedVideo = null;
    this.series_id = null;

    this.liveStreamService.getStreamDetail(streamId).subscribe({
      next: (stream) => {
        // Backend wraps in { data: ... }; service already unwraps lists but not single objects.
        const s: any = (stream as any)?.data ?? stream;
        this.liveStream = s;
        this.videoTitle = s?.title || 'Live Stream';
        this.liveViewerCount = s?.viewerCount || 0;
        this.selectedVideo = {
          vidLibId: streamId,
          videoTitle: this.videoTitle,
          preparedVideoType: s?.accessType || 'FREE',
          isChannelSubscribed: true,
          isPpvSubscribed: true,
          isLive: true
        };

        // Always attempt playback — backend status often lags behind actual broadcast state.
        // If no playback URL is returned, we fall back to the waiting overlay.
        this.fetchPlaybackAndStart(streamId);
      },
      error: (err) => {
        console.error('Failed to load live stream detail:', err);
        this.isLoading = false;
      }
    });
  }

  private fetchPlaybackAndStart(streamId: number): void {
    this.liveStreamService.getPlaybackUrl(streamId).subscribe({
      next: (response: any) => {
        const data = response?.data ?? response;
        const isApple = this.isSafariApple();
        // this.mediaUrl = (isApple && data?.hlsUrl) ? data.hlsUrl : (data?.dashUrl || data?.hlsUrl);
        this.mediaUrl = data?.hlsUrl;
        const licenseUrl = data?.licenseUrl;

        if (!this.mediaUrl) {
          console.error('No playback URL returned for live stream', streamId);
          this.isLoading = false;
          return;
        }
        this.initLivePlayer(licenseUrl);
        this.startViewerLifecycle(streamId);
      },
      error: (err) => {
        console.error('Failed to load playback URL:', err);
        this.isLoading = false;
      }
    });
  }

  private async initLivePlayer(licenseUrl: string): Promise<void> {
    if (!this.customPlayerRef) {
      setTimeout(() => this.initLivePlayer(licenseUrl), 100);
      return;
    }
    try {
      if (this.player) {
        try { await this.player.destroy(); } catch {}
        this.player = null;
      }
      shaka.polyfill.installAll();
      if (!shaka.Player.isBrowserSupported()) {
        console.error('Shaka not supported on this browser');
        return;
      }
      const absoluteLicenseUrl = licenseUrl && /^https?:\/\//i.test(licenseUrl)
        ? licenseUrl
        : `${environment.baseUrl.replace(/\/$/, '')}${licenseUrl?.startsWith('/') ? '' : '/'}${licenseUrl || ''}`;

      const drmConfig = {
        servers: {
          'com.widevine.alpha': absoluteLicenseUrl
        },
        advanced: {
          'com.widevine.alpha': {
            persistentStateRequired: false
          }
        }
      };
      await this.customPlayerRef.initShakaPlayer(this.mediaUrl, drmConfig);
      this.videoElement = this.customPlayerRef.videoElement;
      this.player = this.customPlayerRef.player;
      this.isLoading = false;
      try {
        await this.videoElement.play();
      } catch (e) {
        console.warn('Live auto-play blocked:', e);
      }
    } catch (err) {
      console.error('Live player init error:', err);
      this.isLoading = false;
    }
  }

  private startViewerLifecycle(streamId: number): void {
    this.stopViewerLifecycle();
    this.liveStreamService.joinStream(streamId).subscribe();
    this.liveHeartbeatSub = interval(30000).subscribe(() => {
      this.liveStreamService.sendHeartbeat(streamId).subscribe();
    });
    this.liveViewerPollSub = interval(15000).subscribe(() => {
      this.liveStreamService.getViewerCount(streamId).subscribe({
        next: (res: any) => {
          const count = (res?.data?.viewerCount ?? res?.viewerCount);
          if (typeof count === 'number') this.liveViewerCount = count;
        },
        error: () => {}
      });
    });
  }

  private stopViewerLifecycle(): void {
    if (this.liveHeartbeatSub) { this.liveHeartbeatSub.unsubscribe(); this.liveHeartbeatSub = undefined; }
    if (this.liveViewerPollSub) { this.liveViewerPollSub.unsubscribe(); this.liveViewerPollSub = undefined; }
  }

  onVideoPlay() {
    this.isPlaying = true;
  }

  onVideoPause() {
    this.isPlaying = false;
  }

  onVideoEnded() {
    this.nextVideo();
  }

  onVideoError(error: any) {
    console.error('Video player error:', error);
  }

  onVideoBackClick() {
    this.onBack();
  }

  onMediaUrlChange(newUrl: string) {
    console.log('Media URL changed:', newUrl);
  }

  onEpisodesToggle(isOpen: boolean) {
    this.isMoreLikeThis = isOpen;
    if (isOpen) {
      this.loadEpisodesOrMoreLikeThis();
    }
  }

  private loadEpisodesOrMoreLikeThis() {
    if (this.series_id && (!this.seriesData || this.seriesData.length === 0)) {
      this.getSeriesData(this.series_id);
    } else if (!this.series_id && (!this.moreLikeThis || this.moreLikeThis.length === 0)) {
      this.getMoreLikeVideos();
    }
  }

  playEpisode(episode: any) {    
    this.isMoreLikeThis = false;
    this.clearNextVideoCountdown();
    const route = this.whitelabelService.getPrefixedRoute('shows', episode.tqrVideoBean.series_id, episode.tqrVideoBean.title, episode.tqrVideoBean.vidLibId, 'watch');
    if (this.iosBridgeService.isIOS()) {
      const payload = {
        video: episode?.tqrVideoBean,
        returnRoute: this.router.url,
        playerUrl: `${this.iosBridgeService.getCurrentDomain()}${route}?aspect=${episode?.tqrVideoBean?.mediaLayout}`,
      };
      this.iosBridgeService.openVideoPlayer(payload);
      return;
    }
    this.router.navigate([route]);
  }

  onBack() {
    this.location.back();
  }

  nextVideo(): void {
    if (this.isLive) {
      return;
    }
    if (this.series_id) {
      this.nextVideoItem = this.findNextEpisode();
      if (this.nextVideoItem) {
        this.startNextVideoCountdown();
      } else {
        this.navigateToSeriesPage();
      }
    } else {
      this.navigateToVideoDetails();
    }
  }

  private startNextVideoCountdown() {
    this.isNextVideoPreview = true;
    this.delayTimer = 3;
    this.countdownInterval = setInterval(() => {
      this.delayTimer--;
      if (this.delayTimer <= 0) {
        this.clearNextVideoCountdown();
        this.openNextVideo();
      }
    }, 1000);
  }

  private clearNextVideoCountdown() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
    this.isNextVideoPreview = false;
    this.delayTimer = 3;
  }

  private navigateToSeriesPage() {
    if (this.seriesData && this.seriesData.length > 0) {
      const firstSeason = this.seriesData[0];
      const firstEpisode = firstSeason.episodes[0];
      const route = this.whitelabelService.getPrefixedRoute('shows', this.series_id);
      this.router.navigate([route]);
    }
  }

  private navigateToVideoDetails() {
    const route = this.whitelabelService.getPrefixedRoute('movies', this.selectedVideo.title, this.selectedVideo.vidLibId);
    this.router.navigate([route]);
  }

  skipDelay(): void {
    this.clearNextVideoCountdown();
  }

  openNextVideo(): void {
    this.clearNextVideoCountdown();
    console.log('nextitem',this.nextVideoItem)
    const route = this.whitelabelService.getPrefixedRoute('shows', this.nextVideoItem.tqrVideoBean.series_id, this.nextVideoItem.tqrVideoBean.title, this.nextVideoItem.tqrVideoBean.vidLibId, 'watch');
    if (this.iosBridgeService.isIOS()) {
      const payload = {
        video: this.nextVideoItem?.tqrVideoBean,
        returnRoute: this.router.url,
        playerUrl: `${this.iosBridgeService.getCurrentDomain()}/${route}?aspect=${this.nextVideoItem?.tqrVideoBean?.mediaLayout}`,
      };
      this.iosBridgeService.openVideoPlayer(payload);
      return;
    }
    this.router.navigate([route], {
      replaceUrl: true,
      queryParams: {
        aspect: this.nextVideoItem?.tqrVideoBean?.mediaLayout
      }
    });    
  }

  findNextEpisode() {
    if (!this.seriesData || !this.selectedVideo) return null;
    const currentSeasonIndex = this.seriesData.findIndex(
      season => season.seasonId == this.selectedVideo.season_id
    );
    const currentEpisodeNumber = this.selectedVideo.episode_number;
    if (currentSeasonIndex === -1 || !this.selectedSeason) return null;
    if (currentEpisodeNumber < this.selectedSeason.episodes.length) {
      return this.selectedSeason.episodes[currentEpisodeNumber];
    }
    if (currentSeasonIndex < this.seriesData.length - 1) {
      const nextSeason = this.seriesData[currentSeasonIndex + 1];
      if (nextSeason.episodes && nextSeason.episodes.length > 0) {
        return nextSeason.episodes[0];
      }
    }
    return null;
  }

  isCurrentVideoPlaying(episode: any): boolean {
    this.currentlyPlayingEpisodeId = this.vidLibId;
    return this.currentlyPlayingEpisodeId == episode.tqrVideoBean.vidLibId;
  }

  getSeriesData(seriesId: number) {
    if (!seriesId) return;
    this.http.post(`${URLS.getEpisodicConent}?series_id=${seriesId}`, {})
      .subscribe({
        next: (result: any) => {
          this.processSeriesData(result.data.seasons);
        },
        error: (error) => {
          console.error('Error fetching series data:', error);
        }
      });
  }

  private processSeriesData(seasons: any) {
    this.seriesData = seasons.map((season: any) => {
      return {
        ...season,
        episodes: season.episodes.map((episode: any) => {
          return {
            tqrVideoBean: this.mycontentserviceService.transformData(episode.tqrVideoBean),
            ...episode,
          };
        })
      };
    });

    if (this.selectedVideo) {
      this.setCurrentSeasonAndEpisode();
    }
  }

  private setCurrentSeasonAndEpisode() {
    const presentSelectedSeasonId = this.selectedVideo.season_id;
    const presentSelectedEpisodeNumber = this.selectedVideo.episode_number;
    if (presentSelectedSeasonId) {
      this.selectedSeason = this.seriesData.find(
        (season: any) => season.seasonId == presentSelectedSeasonId
      );
      if (this.selectedSeason) {
        this.selectedEpisode = this.selectedSeason.episodes.find(
          (episode: any) => episode.episodeNumber == presentSelectedEpisodeNumber
        );
        this.activeTab = this.selectedSeason.seasonId;
      }
    }
  }

  onSeasonChange(seasonId: string) {
    if (this.seriesData) {
      this.selectedSeason = this.seriesData.find(season => season.seasonId == seasonId);
      this.activeTab = seasonId;
    }
  }

  getStreamFile(videoOrId: any, suffix: string = '_drm_meta.mpd'): string {
    return getVideoStreamFile(videoOrId, suffix);
  }

  async getSelectedVideo(vidLibId: any): Promise<void> {
    if (!vidLibId) {
      console.warn('No vidLibId provided');
      return;
    }
    this.isLoading = true;
    this.cdr.detectChanges(); 
    if (this.offlineUri) {
      try {
        const content = await this.getStorageContentWithRetry();
        if (!content || content.length === 0) {
          console.warn('No content found in storage.');
          return;
        }
        const offlineVideo = content.find((video: any) => video.offlineUri === this.offlineUri);
        if (offlineVideo) {
          let processedVideo = { ...offlineVideo };
          if (offlineVideo.appMetadata?.thumbnail instanceof Blob) {
            processedVideo.appMetadata.downloadBlob = URL.createObjectURL(offlineVideo.appMetadata.thumbnail);
          } else {
            processedVideo.appMetadata = processedVideo.appMetadata || {};
            processedVideo.appMetadata.downloadBlob = './assets/img/thumbnail.png';
          }
          if (!processedVideo.thumbnailUrl) {
            processedVideo.thumbnailUrl = processedVideo.appMetadata.downloadBlob;
          }
          if (processedVideo.appMetadata) {
            processedVideo.vidLibId = processedVideo.appMetadata.vidLibId;
            processedVideo = { ...processedVideo, ...processedVideo.appMetadata };
          }
          this.selectedVideo = {
            ...processedVideo,
            preparedVideoType: 'FREE',
            isChannelSubscribed: true,
            isPPVSubscribed: true
          };
          // this.videoTitle = this.selectedVideo.title || 'Offline Video';
          this.isLoading = false;
          this.cdr.detectChanges(); 
          this.handleVideoLoad(this.selectedVideo);
        } else {
          const route = this.whitelabelService.getPrefixedRoute('downloads');
          this.router.navigate([route]);
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      } catch (error) {
        console.error('🎬 Error getting offline video data:', error);
        const route = this.whitelabelService.getPrefixedRoute('downloads');
        this.router.navigate([route]);
        this.isLoading = false;
        this.cdr.detectChanges();
        return;
      }
    } else {
      forkJoin({
        videoResult: this.categService.getPrimeVideo(vidLibId).pipe(
          map((result: any) => {
            if (!result) {
              throw new Error('No video data found');
            }
            return this.mycontentserviceService.transformVideoData(result.data[0], 'Prime');
          })
        ),
        subscriptions: this.walletService.getUserSubscriptions(),
        watchHistory: this.mycontentserviceService.getContinueWatching()
      })
        .pipe(
          catchError((error) => {
            console.error('Error fetching video data or subscriptions:', error);
            this.isLoading = false;
            this.cdr.detectChanges();
            return throwError(() => error);
          })
        )
        .subscribe({
          next: ({ videoResult, subscriptions, watchHistory }) => {
            this.selectedVideo = videoResult;
            this.mpd_fileName = getVideoStreamFile(videoResult);
            // this.videoTitle = videoResult.title;
            this.mapSubscriptions(videoResult, subscriptions);
            this.mapwatchHistory(videoResult, watchHistory);
            this.selectedVideo.vmapUrl = `${environment.TQR_SERVICE}ads/v2/vmap/${this.vidLibId}?platform=WEB&device=${this.getDeviceType()}`;
            this.isLoading = false;
            this.cdr.detectChanges();
            this.handleVideoLoad(videoResult);
            this.startTime = this.isTrailer ? 0 : this.selectedVideo.secondsWatched;
            this.playerTheme = this.isTrailer ? 'trailer' : this.selectedVideo?.mediaLayout;
            console.log('selected video', this.selectedVideo);
            if(this.selectedVideo.external_source === 'true' && !this.isTrailer){
              this.mediaUrl = `${this.postVideos}${this.selectedVideo?.playback_path}`
            } else if (!this.offlineUri && !this.isTrailer) {
              const isApple = this.isSafariApple();
              const suffix = isApple ? '_master.m3u8' : '_drm_meta.mpd';
              this.mediaUrl = `${this.postVideos}${getVideoStreamFile(this.selectedVideo, suffix)}`;
            }
            this.initPlayer();
            if(this.selectedVideo?.series_id){
              this.selectedVideo.poster = this.postVideos + 'SER_' + this.series_id + '_thumb_v.jpg';
            }else{
              this.selectedVideo.poster = getVideoThumbnail(this.selectedVideo);
            }
          },
          error: (error) => {
            console.error('Error in processing video details:', error);
            this.isLoading = false;
            this.cdr.detectChanges();
          }
        });
    }
  }

  async getStorageContentWithRetry(retries = 3, delay = 500): Promise<any[]> {
    let content;
    for (let attempt = 0; attempt < retries; attempt++) {
      try {
        content = await window.storage?.list();
        if (content && content.length > 0) {
          return content;
        }
      } catch (error) {
        console.error('Error fetching from storage on attempt', attempt + 1, error);
      }
      await this.delay(delay);
    }
    return [];
  }
  
  delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  
  private mapSubscriptions(video: any, subscriptions: any[]) {
    subscriptions.forEach((sitem) => {
      if (video.channelId == sitem.channelId && sitem.isActive) {
        video.isChannelSubscribed = true;
        video.expiringDate = sitem.dateOfExpiry;
      }
      if ((video.vidLibId == sitem.contentId || video.vidLibId == sitem.vidLibId) && sitem.isActive) {
        video.isPPVSubscribed = true;
        video.expiringDate = sitem.dateOfExpiry;
      }else if(video.channelId == sitem.channelId && sitem.isActive && video.ppv_subscribed === '0'){
        video.isPPVSubscribed = true;
        video.expiringDate = sitem.dateOfExpiry;
      }
    });
  }

  mapwatchHistory(video: any, watchHistory: any[]) {
    const whitem = watchHistory.find(w => w.vidLibId == video.vidLibId);
    if (whitem) {
      video.watchedPercentage = whitem.watchedPercentage;
      video.secondsWatched = whitem.secondsWatched;
    }   
  }

  private handleVideoLoad(video: any) {
    if (this.shouldBlockVideo(video)) {
      return;
    }

    this.triggerVideoReload();

    if (video.series_id) {
      this.getSeriesData(video.series_id);
    } else {
      this.getMoreLikeVideos();
    }
  }

  private shouldBlockVideo(video: any): boolean {
    return (!video?.isChannelSubscribed && video?.preparedVideoType === 'Sub') || (!video?.isPPVSubscribed && video?.preparedVideoType === 'PPV');
  }

  shouldShowVideoPlayer(): boolean {
    const result = this.selectedVideo && this.mediaUrl && 
                  (this.offlineUri || 
                   (this.selectedVideo?.preparedVideoType === 'FREE') || 
                   (this.selectedVideo?.preparedVideoType === 'Sub' && this.selectedVideo?.isChannelSubscribed) || 
                   (this.selectedVideo?.preparedVideoType === 'PPV' && this.selectedVideo?.isPPVSubscribed));
    return result;
  }

  private triggerVideoReload() {
    // if (this.customPlayerRef && this.mediaUrl) {
    //   const currentUrl = this.mediaUrl;
    //   this.mediaUrl = ''; 
    //   setTimeout(() => {
    //     this.mediaUrl = currentUrl;
    //   }, 100);
    // }
  }

  getMoreLikeVideos() {
    const category = localStorage.getItem('category') ? localStorage.getItem('category') : '56';
    this.categService.sectionsByCategoryAndChannelId(category, '0', '15')
      .subscribe({
        next: (result) => {
          this.processMoreLikeThis(result);
        },
        error: (error) => {
          console.error('Error fetching more like this:', error);
        }
      });
  }

  private processMoreLikeThis(result: any[]) {
    const filtered = result.filter(item => item.vidLibId != this.vidLibId);
    filtered.forEach((item) => {
      console.log(item.vidLibId === this.vidLibId)
      if(item.vidLibId != this.vidLibId){
        this.mycontentserviceService.transformData(item);
      }
    });
    this.moreLikeThis = filtered;
    this.mapwatchContent(this.moreLikeThis);
    this.mapSubscription(this.moreLikeThis);
  }

  @HostListener('window:mousemove')
  @HostListener('window:click')
  @HostListener('window:keydown')
  onUserInteraction() {
    this.showControls();
  }

  private setMouseActivityListeners() {
    this.showControls();
  }

  private showControls() {
    this.controlsHidden = false;
    if (this.hideControlsTimeout) {
      clearTimeout(this.hideControlsTimeout);
    }
    this.hideControlsTimeout = setTimeout(() => {
      this.controlsHidden = true;
    }, 3000);
  }

  showPlansModal(hoveredMovie: any) {
    const route = this.whitelabelService.getPrefixedRoute('channelplans');
    this.router.navigate([route], {
      queryParams: {
        channelId: hoveredMovie?.channelId,
        channelName: hoveredMovie?.channel_desc,
        vidLibId: hoveredMovie?.vidLibId
      }
    });
  }

  openPayments(hoveredMovie: any) {
    const route = this.whitelabelService.getPrefixedRoute('payment');
    this.router.navigate([route], {
      queryParams: {
        type: 'ppv',
        vidLibId: hoveredMovie?.vidLibId,
        movie: hoveredMovie?.title,
        durId: '2',
        planAmount: hoveredMovie.isChannelSubscribed ? hoveredMovie?.ppv_subscribed : hoveredMovie?.ppv_unsubscribed,
        durationName: hoveredMovie?.ppv_valid_for + ' days',
        currency: hoveredMovie.currencyCode,
        currencySymbol: hoveredMovie.currencySymbol
      }
    });
  }

  getPropertyValue(video: any, name: string): string | undefined {
    if (!video?.tqrVideoBean?.properties) return undefined;
    const prop = video.tqrVideoBean.properties.find((prop: any) => prop.name === name);
    return prop ? prop.value : undefined;
  }

  mapwatchContent(content: any[]) {
    const usrId = localStorage.getItem("userId");
    if (!usrId || !content) return;

    this.mycontentserviceService.getWatchListOfUser(usrId)
      .subscribe({
        next: (watchresult) => {
          content.forEach(section => {
            section.isInWatchList = false;
            watchresult.forEach((wlitem: any) => {
              if (section.vidLibId == wlitem.vidLibId) {
                section.isInWatchList = true;
              }
            });
          });
        },
        error: (error) => {
          console.error('Error mapping watch content:', error);
        }
      });
  }

  mapSubscription(content: any[]) {
    if (!content) return;

    this.walletService.getUserSubscriptions()
      .subscribe({
        next: (result) => {
          content.forEach(section => {
            section.expiringDate = '';
            result.forEach((sitem: any) => {
              if (section.channelId == sitem.channelId && sitem.isActive) {
                section.isChannelSubscribed = true;
                section.expiringDate = sitem.dateOfExpiry;
              }
              if (section.vidLibId == sitem.vidLibId && sitem.isActive) {
                section.isPPVSubscribed = true;
                section.expiringDate = sitem.dateOfExpiry;
              }
            });
          });
        },
        error: (error) => {
          console.error('Error mapping subscriptions:', error);
        }
      });
  }

  onVideoTimeUpdate(currentTime: number) {
    if (typeof currentTime === 'number' && !isNaN(currentTime) && currentTime >= 0) {
      this.currentVideoRunningTime = currentTime;
    } else {
      console.warn('Invalid currentTime received:', currentTime);
    }
  }

  updateWatchHistory() {
    if (!this.userId || (!this.vidLibId && !this.isTrailer)) return;
    const activePlayer = this.customPlayerRef || this.iosPlayerRef;
    const sessionSeconds = activePlayer ? activePlayer.flushSessionWatchTime()/1000 : Math.round(this.currentVideoRunningTime)/1000;
    if (sessionSeconds <= 0) return;
    const requestBody: any = {
      "channel": this.selectedVideo?.channelId,
      "isDrmVideo": "1",
      "playBackMode": 'server',
      "secondsWatched": `${sessionSeconds}`,
      "currentPlaybackPosition": `${this.currentVideoRunningTime}`,
      "subtitleLanguage": "Stereo, 0.13 Mbps",
      "videoDuration": `${activePlayer?.duration || 0}`,
      "videoFileSIze": `${this.videoFileSize}`,
      "videoId": this.vidLibId,
      "videoType": this.selectedVideo?.videoType,
      "createdOn": this.formatDateTime(),
      "eventId": "13",
      "eventType": '13',
      "userId": this.userId.toString(),
      "playState": "3",
      "platformType": this.deviceService.getPlatformType()
    };
    if(this.isTrailer){
      requestBody.trailerTitle = this.videoTitle,
      requestBody.contentType = "TRAILER"
    }
    this.mycontentserviceService.updateUserVideoTracking(requestBody)
      .subscribe({
        next: (res) => {
          console.log("Watch history updated — session watch time:", sessionSeconds, "s");
        },
        error: (error) => {
          console.error("Error updating watch history:", error);
        }
      });
  }

  insertWatchEntry() {
    if (!this.userId || !this.vidLibId) return;
    const activePlayer = this.customPlayerRef || this.iosPlayerRef;
    const incrementMs = activePlayer ? activePlayer.flushSessionWatchTime() : 0;
    if (incrementMs <= 0) return;
    const requestBody = {
      vidLibId: this.vidLibId,
      lastPositionMs: Math.round(this.currentVideoRunningTime * 1000),
      durationMs: Math.round((activePlayer?.duration || 0) * 1000),
      channelId: `${this.selectedVideo?.channelId}`,
      incrementWatchTimeMs: Math.round(incrementMs)
    };
    this.mycontentserviceService.insertWatchHistory(requestBody)
      .subscribe({
        next: (res) => {
          console.log('Watch history upserted:', res);
        },
        error: (error) => {
          console.error('Error upserting watch history:', error);
        }
      });
  }

  formatDateTime(): string {
    const currentDate = new Date();
    return currentDate.getDate() + '-' + currentDate.toLocaleString('default', { month: 'short' }) + '-' + currentDate.getFullYear() + ' ' + currentDate.getHours() + ':' + currentDate.getMinutes() + ':' + currentDate.getSeconds();
  }

  shouldShowEpisodesButton(): boolean {
    return !!(this.series_id && this.seriesData?.length > 0) || 
           (!this.series_id && this.moreLikeThis?.length > 0);
  }

  hasEpisodes(): boolean {
    return !!(this.series_id && this.seriesData?.length > 0);
  }

  hasMoreLikeThis(): boolean {
    return !this.series_id && this.moreLikeThis?.length > 0;
  }

  private getDeviceType(): string {
    if (this.deviceService.isTV()) {
      return 'CTV';
    }
    if (this.deviceService.isMobile()) {
      return 'MOBILE';
    }
    if (this.deviceService.isTablet()) {
      return 'TABLET';
    }
    return 'DESKTOP';
  }

  private isSafariApple(): boolean {
    const ua = navigator.userAgent;
    const isApple = /Macintosh|iPad|iPhone|iPod/.test(ua);
    const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
    return isApple && isSafari;
  }

}










































// if (!this.offlineUri) {
//   const token: string = localStorage.getItem('token') || '';
//   this.drmConfig = {
//     preferredAudioLanguage: 'en',
//     servers: {
//       'com.widevine.alpha': `https://widevine-dash.ezdrm.com/proxy?pX=C487BC&userId=${token}&channelId=${this.channelId}&vidLibId=${this.vidLibId}&videoType=${this.videoType}`
//     },
//     advanced: {
//       'com.widevine.alpha': {
//         persistentStateRequired: true
//       }
//     },
    // clearKeys: {
    //   '7957ae9a86a557b499a24bab68e09018': '45126fdb266c25e790d26773c384f620',
    //   'e137165c1df2b5c0c82d5d9c5a49556e': 'cc261d2691530d85b9c2715760f78d76'
    // }
//   };
// }




// import { Component, ElementRef, ViewChild ,OnDestroy, HostListener} from '@angular/core';
// import { ActivatedRoute, Router } from '@angular/router';
// import { MycontentserviceService } from 'src/app/_service/mycontentservice.service';
// import { CategoryService } from 'src/app/_service/category.service';
// import { Subscription, throwError } from 'rxjs';
// import { URLS } from 'src/app/constants/URLS';
// import { catchError, map, switchMap } from 'rxjs/operators';
// import { HttpClient } from '@angular/common/http';
// import { IndexedDbServiceService } from 'src/app/_service/indexed-db-service.service';
// import { WalletinfoService } from 'src/app/_service/walletinfo.service';

// declare let shaka: any;
// declare var window:any;

// @Component({
//   selector: 'app-shaka-player',
//   templateUrl: './shaka-player.component.html',
//   styleUrls: ['./shaka-player.component.css'],
// })
// export class ShakaPlayerComponent implements OnDestroy {
//   @ViewChild('videoPlayer', {static:true}) videoElementRef!: ElementRef<HTMLVideoElement>;
//   @ViewChild('videoContainer', {static:true}) videoContainerRef!: ElementRef<HTMLDivElement>;

//   videoElement: HTMLVideoElement | undefined;
//   videoContainerElement: HTMLDivElement | undefined;
//   private currentVideoRunningTime: number = 0; 
//   private ui: any; 
//   private player: any;
//   mpd_fileName:String;
//   userId:Number;
//   channelId:number;
//   vidLibId:number;
//   videoType:String;
//   videoDuration: number = 0;
//   videoFileSize: number = 0;
//   url:string = URLS.BASE_URL;
//   mediaUrl: string = this.url + '/static/post_videos/';
//   offlineUri: string = '';
//   isMoreLikeThis:boolean = false;
//   moreLikeThis:any[] = [];
//   series_id:any;
//   private routeSubscription: Subscription | undefined;
//   title:string = '';
//   private storage:any;
//   seriesData:any;
//   seasons:any[] = [];
//   selectedVideo:any;

//   constructor( 
//     private route: ActivatedRoute,
//     private mycontentserviceService: MycontentserviceService,
//     private categService: CategoryService,
//     private http:HttpClient,
//     private indexedDBService: IndexedDbServiceService,
//     private router:Router,
//     private walletService: WalletinfoService,
//     ) {}

//   ngOnInit() {
//     this.setMouseActivityListeners();
//     this.route.queryParams.subscribe(params => {
//       this.channelId = params['channelId'];
//       this.vidLibId =  params['vidLibId'];
//       this.mpd_fileName = `VID_${params['vidLibId']}_drm_meta.mpd`;
//       this.series_id = params['series_id'];
//       if(this.player){
//         // window.location.reload();
//         this.initPlayer();
//       }
//       if(this.vidLibId){
//         // this.initPlayer();
//         this.getSelectedVideo(this.vidLibId);
//       }
//       this.videoType= params['videoType'];
//       this.userId=Number(localStorage.getItem('userId'));;
//       this.currentVideoRunningTime = params['secondsWatched'] ?? 0;
//       this.videoDuration = params['duration'];
//       this.videoFileSize = params['videoSize'];
//       this.userId=Number(localStorage.getItem('userId'));
//       this.offlineUri = params['offlineUri'];
//      });
//      if(this.offlineUri){
//       this.initPlayer();
//       console.log('offline video');
//       console.log("insinde my content service part", this.mycontentserviceService.recentDownloadedofflineUri);
//      this.mediaUrl = this.offlineUri;
//     }else {
//       console.log("insinde params block")
//       this.mediaUrl += this.mpd_fileName;
//     }
//     const videoElement = document.getElementById('videoPlayer');
//     videoElement?.addEventListener("timeupdate", () => {
//       this.currentVideoRunningTime = this.videoElement?.currentTime;
//     });
//   }

//   private async initPlayer() {
//     shaka.polyfill.installAll();
  
//     if (!shaka.Player.isBrowserSupported()) {
//       console.error('Shaka Player is not supported in this browser.');
//       return;
//     }
  
//     this.videoElement = this.videoElementRef.nativeElement;
//     this.videoContainerElement = this.videoContainerRef.nativeElement;
  
//     if (!this.player) {
//       this.player = new shaka.Player(this.videoElement);
//       this.ui = new shaka.ui.Overlay(this.player, this.videoContainerElement, this.videoElement);
  
//       const config = {
//         addSeekBar: true,
//         seekBarColors: {
//           base: 'rgba(255, 255, 255, 0.3)',
//           buffered: 'rgba(255, 255, 255, 0.54)',
//           played: '#0f79af'
//         }
//       };
//       this.ui.configure(config);
//     }
  
//     if (!shaka.ui.Controls) {
//       console.error('Shaka UI Controls not loaded!');
//     }
  
//     await this.indexedDBService.ensureDbInitialized();
  
//     const token: string = localStorage.getItem('token');
//     const drmServersConfig = {
//       'com.widevine.alpha': `https://widevine-dash.ezdrm.com/proxy?pX=C487BC&userId=${token}&channelId=${this.channelId}&vidLibId=${this.vidLibId}&videoType=${this.videoType}`
//     };
  
//     const storedLicense = await this.indexedDBService.getLicense('widevine-license');
//     console.log('Using stored license:', storedLicense);
  
//     this.player.configure({
//       preferredAudioLanguage: 'hi',
//       drm: {
//         servers: drmServersConfig,
//         advanced: {
//           'com.widevine.alpha': {
//             persistentStateRequired: true
//           }
//         },
//         clearKeys: {
//           '7957ae9a86a557b499a24bab68e09018': '45126fdb266c25e790d26773c384f620',
//           'e137165c1df2b5c0c82d5d9c5a49556e': 'cc261d2691530d85b9c2715760f78d76'
//         }
//       }
//     });
  
//     try {
//       await this.player.load(this.mediaUrl);
  
//       if (this.selectedVideo.secondsWatched && this.selectedVideo.secondsWatched > 0) {
//         this.videoElement.currentTime = this.selectedVideo.secondsWatched;
//       }

//       this.videoElement.play();
//     } catch (error) {
//       console.error('Error loading video with DRM config:', error);
//     }
//   }
  

//   private loadVideo() {
//     this.player.load(this.mediaUrl)
//       .then(() => {
//         this.videoElement.play();
//       })
//       .catch((error: any) => {
//         console.error('Error loading video:', error);
//       });
//   }

//   updateWatchHistory() {
//     const requestBody = {
//       "channel": this.channelId,
//       "isDrmVideo": "1",
//       "playBackMode": 'server',
//       "playState": "0",
//       "secondsWatched": `${this.currentVideoRunningTime}`,
//       "subtitleLanguage": "Stereo, 0.13 Mbps",
//       "videoDuration": `${this.videoDuration}`,
//       "videoFileSIze": `${this.videoFileSize}`,
//       "videoId": this.vidLibId,
//       "videoType": this.videoType,
//       "createdOn": this.formatDateTime(),
//       "eventId": "13",
//       "eventType": '13',
//       "userId": this.userId.toString()
//     }
//     this.mycontentserviceService.updateUserWatchHistory(requestBody).subscribe( res =>{
//       console.log("video added to user watch hoistory 3")
//     });
//   }

//   formatDateTime(){
//     const currentDate = new Date();
//     return currentDate.getDate()+'-'+currentDate.toLocaleString('default', {month: 'short'})+'-'+currentDate.getFullYear()+' '+ currentDate.getHours()+':'+currentDate.getMinutes()+':'+currentDate.getSeconds();
//   }

//   ngOnDestroy(): void {
//     if (this.player) {
//       this.player.destroy().then(() => {
//         console.log('Player destroyed successfully');
//       }).catch(err => {
//         console.error('Error destroying player:', err);
//       });
//       this.player = null; 
//     }
//     if (this.routeSubscription) {
//       this.routeSubscription.unsubscribe();
//     }
//     if (this.countdownInterval) {
//       clearInterval(this.countdownInterval);
//     }
//     if (!this.offlineUri) {
//       this.updateWatchHistory();
//     }
//   }

//   currentlyPlayingEpisodeId: any | null = null;
//   isCurrentVideoPlaying(episode: any): boolean {
//     this.currentlyPlayingEpisodeId = this.vidLibId
//     return this.currentlyPlayingEpisodeId == episode.tqrVideoBean.vidLibId;
//   }

//   getSeriesData(seriesId:number){
//     this.http.post(`${URLS.getEpisodicConent}?series_id=${seriesId}`,{}).subscribe((result:any)=>{
//       console.log(result);
//       this.seriesData = result.data.seasons;
//       console.log('series', this.seriesData);
//       this.seriesData = this.seriesData.map((season: any) => {
//         return {
//           ...season,
//           episodes: season.episodes.map((episode: any) => {
//             return {
//               tqrVideoBean: this.mycontentserviceService.transformData(episode.tqrVideoBean),
//               ...episode,
//             };
//           })
//         };
//       });
//       console.log(this.seriesData);
//       if(this.selectedVideo){
//         const presentSelectedSeasonId = this.selectedVideo.season_id;
//         const presentSelectedEpisodeNumber = this.selectedVideo.episode_number;
//         if(presentSelectedSeasonId){
//           this.selectedSeason = this.seriesData.find((season:any)=>season.seasonId == presentSelectedSeasonId);
//           this.selectedEpisode = this.selectedSeason.episodes.find((episode)=>episode.episodeNumber == presentSelectedEpisodeNumber);
//           console.log('episode', this.selectedEpisode);
//           console.log('season',this.selectedSeason);
//           this.activeTab = this.selectedSeason.seasonId;
//         }
//       }
//     })
//   }

//   processResponse(response: any) {
//     const seriesData = response.seasons;
//     this.seriesData = this.convertObjectToArray(seriesData);
//     if(this.seriesData.length>0){
//       this.selectedSeason = this.seriesData[0];
//       this.activeTab = this.selectedSeason.seasonId;
//       console.log(this.selectedSeason)
//     }
//   }

//   selectedSeason: any; 
//   selectedEpisode:any;
//   activeTab:any = '';
//   onSeasonChange(seasonId: string) {
//     if(this.seriesData){
//       this.selectedSeason = this.seriesData.find(season => season.seasonId == seasonId);
//       this.activeTab = seasonId;
//       console.log(this.selectedSeason)
//     }
//   }

//   convertObjectToArray(obj: any): any[] {
//     return Object.keys(obj).map((seasonId, seasonNumber) => {
//       return {
//         seasonId,
//         seasonNumber,
//         value: obj[seasonId],
//         episodes: this.convertEpisodesToArray(obj[seasonId].episodeMap)
//       };
//     });
//   }

//   convertEpisodesToArray(episodeMap: any): any[] {
//     return Object.keys(episodeMap).map(episodeKey => {
//       return {
//         episodeKey,
//         ...episodeMap[episodeKey]
//       };
//     });
//   }

//   getPropertyValue(video: any, name: string): string | undefined {
//     const prop = video.tqrVideoBean.properties.find((prop: any) => prop.name === name);
//     return prop ? prop.value : undefined;
//   }

//   getSelectedVideo(vidLibId: any): void {
//     this.http
//       .post(`${URLS.getSectionsContent}?video_type=premium&vidLibList=${vidLibId}`, {})
//       .pipe(
//         map((result: any) => this.mycontentserviceService.transformVideoData(result.data[0], 'Prime')),
//         switchMap((video: any) => {
//           this.selectedVideo = video;
//           this.title = video.title;

//           console.log(video)
//           return this.walletService.getUserSubscriptions().pipe(
//             map((subscriptions: any[]) => {
//               subscriptions.forEach((sitem) => {
//                 if (video.channelId == sitem.channelId && sitem.isActive) {
//                   video.isChannelSubscribed = true;
//                   video.expiringDate = sitem.dateOfExpiry;
//                 }
//                 if (video.vidLibId == sitem.vidLibId && sitem.isActive) {
//                   video.isPPVSubscribed = true;
//                   video.expiringDate = sitem.dateOfExpiry;
//                 }
//               });
//               return video;
//             })
//           );
//         }),
//         catchError((error) => {
//           console.error('Error fetching video data or subscriptions', error);
//           return throwError(() => error);
//         })
//       )
//       .subscribe(
//         (video) => {
//           console.log(video);
//           if ((!video?.isChannelSubscribed && video?.preparedVideoType === 'Sub')|| (!video?.isPPVSubscribed && video?.preparedVideoType === 'PPV')) {
//             console.log('User not subscribed to this video');
//             return;
//           }
//           this.initPlayer();
  
//           if (video.series_id) {
//             this.getSeriesData(video.series_id);
//           } else {
//             this.getMoreLikeVideos();
//           }
//           console.log(video);
//         },
//         (error) => {
//           console.error('Error in processing video details', error);
//         }
//       );
//   }
  
//   nextVideoItem:any;
//   delayTimer: number;
//   isNextVideoPreview: boolean = false;
//   countdownInterval: any;

//   nextVideo(): void {
//     if(this.series_id){
//       this.nextVideoItem = this.findNextEpisode();
//       console.log(this.nextVideoItem);
//       if(this.nextVideoItem){
//         this.isNextVideoPreview = true;
//         this.delayTimer = 3;
//           this.countdownInterval = setInterval(() => {
//             this.delayTimer--;
//             if (this.delayTimer <= 0) {
//               clearInterval(this.countdownInterval);
//               this.isNextVideoPreview = false;
//               this.openNextVideo();
//             }
//           }, 1000);
//       }else{
//         let season = this.seriesData[0];
//         let episode = season.episodes[0];
//         this.router.navigate(['/tqr/video-details'],{ queryParams:{ id: episode.tqrVideoBean.vidLibId, series_id: this.series_id } })
//       }
//     }else{
//       this.router.navigate(['/tqr/video-details'],{ queryParams:{ id: this.selectedVideo.vidLibId } })
//     }   
//   }

//   skipDelay():void{
//     if(this.countdownInterval){
//       clearInterval(this.countdownInterval);
//     }
//     this.isNextVideoPreview = false;
//     this.openNextVideo();
//   }

//   openNextVideo(): void {
//     this.router.navigate(['/shaka-player'], {
//       queryParams: {
//         fileName: 'VID_' + this.nextVideoItem.tqrVideoBean.vidLibId + '_drm_meta.mpd',
//         vidLibId: this.nextVideoItem.tqrVideoBean.vidLibId,
//         series_id: this.series_id
//       }
//     }).then(() => {
//       this.vidLibId = this.nextVideoItem.tqrVideoBean.vidLibId;
//       this.mediaUrl = `${this.url}/static/post_videos/VID_${this.nextVideoItem.tqrVideoBean.vidLibId}_drm_meta.mpd`;
//       this.getSelectedVideo(this.nextVideoItem.tqrVideoBean.vidLibId);
//       this.loadVideo();
//     });
//   }

//   findNextEpisode() {
//     let currentSeasonIndex = this.seriesData.findIndex(season => season.seasonId == this.selectedVideo.season_id);
//     let currentEpisodeNumber = this.selectedVideo.episode_number;
//     if (currentEpisodeNumber < this.selectedSeason.episodes.length) {
//       return this.selectedSeason.episodes[currentEpisodeNumber];
//     }
//     if (currentSeasonIndex < this.seriesData.length - 1) {
//       const nextSeason = this.seriesData[currentSeasonIndex + 1];
//       if (nextSeason.episodes && nextSeason.episodes.length > 0) {
//         return nextSeason.episodes[0];
//       }
//     }
//     return null;
//   }

//   getMoreLikeVideos(){
//     this.categService.sectionsByCategoryAndChannelId('56', '0','15').subscribe((result)=>{
//       console.log(result);
//       result.forEach((item)=>{
//         this.mycontentserviceService.transformData(item);
//       })
//       this.moreLikeThis = result;
//       this.mapwatchContent(this.moreLikeThis);
//       this.mapSubscription(this.moreLikeThis);
      
//       console.log(this.moreLikeThis);
//     })
//   }

//   controlsHidden = false;
//   private hideControlsTimeout: any;
//   toggleMoreLikeThis() {
//     this.isMoreLikeThis = !this.isMoreLikeThis;
//   }

//   @HostListener('window:mousemove')
//   @HostListener('window:click')
//   onUserInteraction() {
//     this.showControls();
//   }

//   private setMouseActivityListeners() {
//     this.showControls();
//   }

//   private showControls() {
//     this.controlsHidden = false;
//     clearTimeout(this.hideControlsTimeout);
//     this.hideControlsTimeout = setTimeout(() => {
//       this.controlsHidden = true;
//     }, 3000); 
//   }

//   onBack(){
//     window.history.back();
//   }

//   showPlansModal(hoveredMovie:any){
//     this.router.navigate(['/tqr/channelplans'], {
//       queryParams:{
//         channelId: hoveredMovie?.channelId,
//         channelName: hoveredMovie?.channel_desc,
//         vidLibId: hoveredMovie?.vidLibId
//       }
//     })
//   }

//   openPayments(hoveredMovie:any) {
//     console.log(hoveredMovie)
//     this.router.navigate(['/tqr/payment'], {
//       queryParams: {
//         type: 'ppv',
//         vidLibId: hoveredMovie?.vidLibId,
//         movie: hoveredMovie?.title,
//         durId: '2',
//         planAmount: hoveredMovie.isChannelSubscribed ? hoveredMovie?.ppv_subscribed : hoveredMovie?.ppv_unsubscribed,
//         durationName: '2 Weeks',
//       }
//     });
//   }  

//   mapwatchContent(content:any) {
//     var usrId = localStorage.getItem("userId");
//     this.mycontentserviceService.getWatchListOfUser(usrId).subscribe(watchresult => { 
//       content.forEach(section => {
//         section.isInWatchList = false;
//           watchresult.forEach(wlitem => {
//             if (section.vidLibId == wlitem.vidLibId) {
//               section.isInWatchList = true;
//             }
//           })
//       })
//     });
//   }

//   mapSubscription(content:any) {
//     this.walletService.getUserSubscriptions().subscribe(result =>{
//       content.forEach(section => {
//         section.expiringDate = '';
//         result.forEach(sitem => {
//           if(section.channelId == sitem.channelId && sitem.isActive){
//             section.isChannelSubscribed = true;
//             section.expiringDate = sitem.dateOfExpiry;
//           }
//           if(section.vidLibId == sitem.vidLibId && sitem.isActive){
//             section.isPPVSubscribed = true;
//             section.expiringDate = sitem.dateOfExpiry;
//           }
//         })
//       })
//     })
//   }
// }

// async ngAfterViewInit(): Promise<void> {
    //   shaka.polyfill.installAll();
    //   if (shaka.Player.isBrowserSupported()) {
    //     this.videoElement = this.videoElementRef.nativeElement;
    //     this.videoContainerElement = this.videoContainerRef.nativeElement;
    //     await this.initPlayer();
    //   } else {
    //     console.error('Browser not supported!');
    //   }
    // }
// private async initPlayer(): Promise<void> {
  //   try {
  //     this.player = new shaka.Player(this.videoElement);
  //     this.ui = new shaka.ui.Overlay(this.player, this.videoContainerElement, this.videoElement);
    
  //     const config = {
  //       addSeekBar: true,
  //       seekBarColors: {
  //         base: 'rgba(255, 255, 255, 0.3)',
  //         buffered: 'rgba(255, 255, 255, 0.54)',
  //         played: '#0f79af'
  //       }
  //     };
  //     this.ui.configure(config);
    
  //     await this.indexedDBService.ensureDbInitialized();
    
  //     const token: string = localStorage.getItem('token');
  //     const drmServersConfig = {
  //       'com.widevine.alpha': `https://widevine-dash.ezdrm.com/proxy?pX=C487BC&userId=${token}&channelId=${this.channelId}&vidLibId=${this.vidLibId}&videoType=${this.videoType}`
  //     };
    
  //     const storedLicense = await this.indexedDBService.getLicense('widevine-license');
    
  //     if (storedLicense) {
  //       console.log('Using stored license:', storedLicense);
  //       this.player.configure({
  //         drm: {
  //           servers: drmServersConfig,
  //           advanced: {
  //             'com.widevine.alpha': {
  //               persistentStateRequired: true,
  //               serverCertificate: new Uint8Array([]),
  //             }
  //           }
  //         }
  //       });
  //       this.player.getNetworkingEngine().registerRequestFilter(async(type, request) => {
  //         if (type === shaka.net.NetworkingEngine.RequestType.LICENSE) {
  //           const cachedLicense = await this.indexedDBService.getLicense('widevine-license');
  //           console.log(cachedLicense)
  //           if (cachedLicense) {
  //             request.initData = new Uint8Array(cachedLicense);
  //             request.drmInfo.initData[0].initData = new Uint8Array(cachedLicense)
  //             request.drmInfo.serverCertificate = new Uint8Array(cachedLicense)
  //             console.log(request)
  //           }
  //         }
  //       });
  //     } else {
  //       this.player.configure({
  //         drm: {
  //           servers: drmServersConfig,
  //           advanced: {
  //             'com.widevine.alpha': {
  //               persistentStateRequired: true,
  //               serverCertificate: new Uint8Array([]),
  //             }
  //           }
  //         }
  //       });
    
  //       this.player.getNetworkingEngine().registerResponseFilter((type, response) => {
  //         if (type === shaka.net.NetworkingEngine.RequestType.LICENSE) {
  //           console.log(response)
  //           // const licenseBase64 = shaka.util.Uint8ArrayUtils.toBase64(response.data);
  //           this.indexedDBService.saveLicense('widevine-license', response.data)
  //         }
  //       });
  //     }
    
  //     await this.player.load(this.mediaUrl);
  //     this.videoElement.play();
  //   } catch (error) {
  //     console.error('Error initializing player:', error);
  //   }
  // }

  // private storeLicense(assetUrl: string, license: ArrayBuffer) {
  //   const base64License = this.arrayBufferToBase64(license);
  //   this.indexedDBService.saveLicense('widevine-license', base64License);
  // }

  // private arrayBufferToBase64(buffer: ArrayBuffer): string {
  //   let binary = '';
  //   const bytes = new Uint8Array(buffer);
  //   const len = bytes.byteLength;
  //   for (let i = 0; i < len; i++) {
  //     binary += String.fromCharCode(bytes[i]);
  //   }
  //   return window.btoa(binary);
  // }

  // private base64ToArrayBuffer(base64: string): ArrayBuffer {
  //   const binary_string = window.atob(base64);
  //   const len = binary_string.length;
  //   const bytes = new Uint8Array(len);
  //   for (let i = 0; i < len; i++) {
  //     bytes[i] = binary_string.charCodeAt(i);
  //   }
  //   return bytes.buffer;
  // }
  
  // private uuidToBuffer(uuid: any): ArrayBuffer {
  //   const hex = uuid.replace(/[{}-]/g, '');
  //   const buffer = new ArrayBuffer(hex.length / 2);
  //   const view = new Uint8Array(buffer);
  //   for (let i = 0; i < hex.length; i += 2) {
  //     view[i / 2] = parseInt(hex.substr(i, 2), 16);
  //   }
  //   return buffer
  // }
  
  // this.player
   //   .load('file:///D:/videos/shaka/VID_10771_drm_meta.mpd') //http://www.bok.net/dash/tears_of_steel/cleartext/stream.mpd
    //  .load('https://dev.toqqer.com/toqqer/static/post_videos/'+this.mpd_fileName) //we can do https also
    //.load('https://k8s-toqqerde-main-c3b359b5b6-777987493.ap-south-1.elb.amazonaws.com/toqqer/static/post_videos/'+this.mpd_fileName)
    // .load(this.mediaUrl)
    
    //  .then(() => {
    //   if(!this.offlineUri){
    //     this.videoElement.currentTime = this.currentVideoRunningTime;
    //    }
    //     this.videoElement.play();
       

    //   })
    //   .catch((e: any) => {
    //     console.error(e);
    //   });
  